module.exports = __webpack_public_path__ + "img/batch-processing-documents.6bf6f9da.svg";